<template>
  <router-link
    v-if="lastReceived && dataLastReceived?.stale"
    v-tooltip.bottom="`No pageviews received ${timeAgo}. Check the snippet is still installed.`"
    :to="{ name: ROUTES.SETTINGS_WEBSITE }"
    data-shell="data-status"
    class="flex h-8 shrink-0 items-center gap-2 rounded-lg border border-[color-mix(in_srgb,var(--rm-warning)_45%,transparent)] bg-[var(--rm-warning-soft)] pr-3 pl-2.5 text-[12.5px] font-semibold whitespace-nowrap text-warning">
    <span class="size-2 rounded-full bg-warning" />
    No data since {{ lastReceivedDate }}
  </router-link>

  <span
    v-else-if="lastReceived"
    v-tooltip.bottom="`Data flowing · last pageview ${timeAgo}`"
    data-shell="data-status"
    class="flex size-[30px] shrink-0 items-center justify-center rounded-md hover:bg-tint">
    <StatusLight on />
  </span>

  <!-- Hidden while loading or when the query errored: a transient reporting
       hiccup must not look like a missing snippet. -->
  <router-link
    v-else-if="!isLoadingDataLastReceived && !isErrorDataLastReceived"
    :to="{ name: ROUTES.SETTINGS_WEBSITE }"
    data-shell="data-status"
    title="Go to Settings › Website & install"
    class="flex h-8 shrink-0 items-center gap-2 rounded-lg border border-[color-mix(in_srgb,var(--rm-danger)_45%,transparent)] bg-[var(--rm-danger-soft)] pr-3 pl-2.5 text-[12.5px] font-semibold whitespace-nowrap text-danger">
    <span
      class="size-2 rounded-full bg-danger shadow-[0_0_0_3px_color-mix(in_srgb,var(--rm-danger)_25%,transparent)]" />
    No data
    <span class="font-bold underline underline-offset-3">Install the snippet →</span>
  </router-link>
</template>

<script setup lang="ts">
import StatusLight from '@dashboard/components/common/StatusLight.vue'
import { ROUTES } from '@dashboard/router/routeNames'
import { useReportStore } from '@dashboard/modules/dashboard/stores/reportStore'
import { useTimeAgo } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const reportStore = useReportStore()
const { dataLastReceived, isLoadingDataLastReceived, isErrorDataLastReceived } = storeToRefs(reportStore)

const lastReceived = computed(() => dataLastReceived.value?.last_update)

const timeAgo = useTimeAgo(computed(() => lastReceived.value ?? new Date()))

const lastReceivedDate = computed(() =>
  lastReceived.value
    ? new Date(lastReceived.value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    : ''
)
</script>
